import styles from './LinkButton.module.css'
import { Link } from 'react-router-dom'

interface LinkButtonProps {
    caption: string
    href: string
    icon: any
}

export const LinkButton = (props: LinkButtonProps): JSX.Element => {
    const {
        caption,
        href,
        icon
    } = props

    return (
        <Link to={href} className={styles.LinkButton}>
            <span
                className={styles.LinkButton__IconContainer}
            >{icon}</span>

            <span className={styles.LinkButton__CaptionContainer}>
                <span
                    className={styles.LinkButton__Caption}
                >
                    {caption}
                </span>
            </span>
        </Link>
    )
}